import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/api.service';

@Injectable()
export class FdeDeoDistributorService {

  serviceBaseUrl = 'it/fde2/fdeReport';
  serviceBloombergUrl = 'it/fde2/fdeBloomberg';
  serviceMorningStarUrl = 'it/fde2/fdeMorningStar';
  serviceClientRequestUrl = 'it/fde2/fdeClientRequest';
  serviceNewSecuritiesUrl = 'it/fde2/fdeNewSecurity';

  constructor(private apiService: ApiService) { }

  /**
   * 获取FDE status report list
   */
  fdeDeoDistributorQuery(): Promise<Object> {
    const url = `${this.serviceBaseUrl}/query`;
    const query = {};
    query['fundStatus'] = 2
    return this.apiService.post(url, query);
  }

  /**
   * fde Generator Report
   */
  fdeGeneratorReport(fundCode: string, hstDate: string, settlement: string): Promise<Object> {
    const url = `${this.serviceBaseUrl}/generatorFdeReport`;
    const query = {};
    query['fundId'] =  fundCode;
    query['asOfDate'] = hstDate;
    query['settlement'] = settlement;
    return this.apiService.post(url, query);
  }


  /**
   * send NAV and Holding Report
   */
  sendNavAndHoldingReport(fundCode: string, hstDate: string): Promise<Object> {
    const url = `${this.serviceBaseUrl}/sendNAVAndHoldingReport`;
    const query = {};
    query['fundId'] =  fundCode;
    query['asOfDate'] = hstDate;
    return this.apiService.post(url, query);
  }

  /**
   * 获取FDE 的Bloomberg 的nav list
   * @param fundCode
   * @param hstDate
   */
  fdeBloombergQuery(fundCode: string, hstDate: string): Promise<Object> {
    const url = `${this.serviceBloombergUrl}/nav/query`;
    const query = {};
    query['fundId'] =  fundCode;
    query['hstDate'] = hstDate;
    return this.apiService.post(url, query);
  }

  /**
   * 获取FDE 的Morning Star 的nav list
   * @param fundCode
   * @param hstDate
   */
  fdeMorningStarQuery(fundCode: string, hstDate: string): Promise<Object> {
    const url = `${this.serviceMorningStarUrl}/nav/query`;
    const query = {};
    query['fundId'] =  fundCode;
    query['hstDate'] = hstDate;
    return this.apiService.post(url, query);
  }

  /**
   * 获取FDE 的Client Request 的nav list
   * @param fundCode
   * @param hstDate
   */
  fdeClientRequestQuery(fundCode: string, hstDate: string): Promise<Object> {
    const url = `${this.serviceClientRequestUrl}/nav/query`;
    const query = {};
    query['fundId'] =  fundCode;
    query['hstDate'] = hstDate;
    return this.apiService.post(url, query);
  }

  /**
   * 获取FDE 的Bloomberg 的holding list
   * @param fundCode
   * @param hstDate
   */
  fdeBloombergHoldingQuery(fundCode: string, hstDate: string): Promise<Object> {
    const url = `${this.serviceBloombergUrl}/holding/query`;
    const query = {};
    query['fundId'] =  fundCode;
    query['hstDate'] = hstDate;
    return this.apiService.post(url, query);
  }

  /**
   * 获取FDE 的new securities
   * @param fundCode
   * @param hstDate
   */
  fdeNewSecuritiesQuery(fundCode: string, hstDate: string): Promise<Object> {
    const url = `${this.serviceNewSecuritiesUrl}/query`;
    const query = {};
    query['fundId'] =  fundCode;
    query['hstDate'] = hstDate;
    return this.apiService.post(url, query);
  }

  /**
   * 获取FDE 的new security detail
   * @param fundCode
   * @param hstDate
   */
  fdeNewSecurityDetailQuery(fundId: string, ticker: string, tickerType: string): Promise<Object> {
    const url = `${this.serviceNewSecuritiesUrl}/queryDetail`;
    const query = {};
    query['fundId'] =  fundId;
    query['ticker'] = ticker;
    query['tickerType'] = tickerType;
    return this.apiService.post(url, query);
  }
}
